import { Text } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { type ChangeEventHandler } from "react";
import ConfirmationButton from "src/components/shared/ConfirmationButton/ConfirmationButton";
import { type IGroupOrLabel } from "src/interfaces";
import { Flex } from "src/styled";

import { useGroupContext } from "../../GroupContext";
import ColorPicker from "./ColorPicker";
import {
  DeleteBox,
  GroupItemContainer,
  GroupNameInput,
} from "./GroupItem.styled";
interface Props {
  group: IGroupOrLabel;
}

const GroupItem = ({ group }: Props) => {
  const {
    selectedElement,
    handleEditElement,
    handleSelectElement,
    handleDeleteElement,
  } = useGroupContext();

  const changeName: ChangeEventHandler<HTMLInputElement> = e => {
    handleEditElement({
      groupId: group.groupId ?? "",
      key: "group",
      value: e.target.value,
    });
  };
  const changeColor = (color: string) => {
    handleEditElement({
      groupId: group.groupId ?? "",
      key: "color",
      value: color,
    });
  };

  const handleClick = () => {
    handleSelectElement(group);
  };

  const handleRemove = () => {
    handleDeleteElement(group.groupId ?? "");
  };

  const active = selectedElement?.groupId === group.groupId;

  return (
    <GroupItemContainer onClick={handleClick} active={active}>
      <ConfirmationButton
        actionIcon
        actionIconProps={{ color: "red.5", component: DeleteBox }}
        modalText="Are you sure you want to remove this group?"
        onConfirm={handleRemove}>
        <IconTrash />
      </ConfirmationButton>
      <Flex direction="column" gap={12} flex={1}>
        <Flex align="center" h={60} gap={5} w={200}>
          <Text size="sm">Name:</Text>
          <GroupNameInput
            variant="unstyled"
            value={group.group}
            onChange={changeName}
          />
        </Flex>
        <Flex align="center" gap={5}>
          <Text size="sm">Color:</Text>
          <ColorPicker color={group.color} setColor={changeColor} />
        </Flex>
      </Flex>
    </GroupItemContainer>
  );
};

export default GroupItem;
